import { useState, useEffect } from 'react';
import React from 'react';
import Sidebar from '../Sidebar/Sidebar';

import './TicTacToeGames.css';

export default function VersusComputer() {

  const [gridMemory, setGridMemory] = useState(Array(9).fill(null));
  const [XisNext, setXisNext] = useState(true);
  const [backColor, setBackColor] = useState(Array(9).fill('#2e80b3'));
 
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  function getIaNextIndex() { 
    
    // donne-moi un index différent de ce qui est déjà occupé dans la gridmemory(cad si index déjà cliqué trouve-moi un autre)
    let index = getRandomInt(0, 8);
    while (gridMemory[index] !== null) {
      // Every verifie si chaque element de gridmemory est différent de null, si oui,  break
      if (gridMemory.every(element => element !== null)) {break;}
  
      index = getRandomInt(0, 8);
    }
    return index; //retourne ce que tu m'as trouvé comme index
  };

  useEffect(() => {
    if (XisNext === false && winningLines(gridMemory) === null ) {
      setTimeout(() => {
        const indexIa = getIaNextIndex();
        const gridMemoryCopy = gridMemory.slice();
        gridMemoryCopy[indexIa] = 'O';
        setGridMemory(gridMemoryCopy);
        setXisNext(!XisNext);
      }, 200);
    }
  }, [XisNext]);


  function handleClick(i) {
    if (winningLines(gridMemory) !== null || gridMemory[i] !== null) {
      return; // si winningLines est different de null cad retourne X ou 0,ou si un elmt de gridmemory est different de null cad contient déjà X ou O,  quitte (on ne peut donc plus cliquer)
    }
    const gridMemoryCopy = gridMemory.slice();
    if (XisNext === true) {
      gridMemoryCopy[i] = 'X';
    }
    setGridMemory(gridMemoryCopy); //met à jour le tableau 
    setXisNext(!XisNext); //Le contraire de l'état d'avant: XisNext devient false s'il était à true. Le useState devient false.
  }

  function winningLines(arrayData) {
      const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      // si le premier element de Array est different de null (cad on a déjà cliqué)
      if (arrayData[a] !== null && 
        // et si le premier element de Array est egal au deuxieme elt de Array
        arrayData[a] === arrayData[b] && 
        // et si le premier elmt de Array est egal au troisieme element de Array
        arrayData[a] === arrayData[c]) {
          backColor[a]= '#F33418';
          backColor[b]= '#F33418';
          backColor[c]= '#F33418';
          return arrayData[a];
      }
    }
    return null;
  }

    const winner = winningLines(gridMemory);
    console.log (winner);
    let status;
  
    if (winner !== null) {
      status = `${winner} a gagné !`;
    
    } 
    else if (gridMemory.every(Boolean)) {
      status = 'Match nul !' ;
    }
    else {
      status = `C'est à ${XisNext ? 'X' : 'O'} de jouer.`;
    }
  
  function Reset() {
    setGridMemory(Array(9).fill(null));
    setXisNext(true);
    setBackColor(Array(9).fill('#2e80b3'));
  }

  function Grid({value, onSquareClick, gridBackColor }) {
    return (
      <button className="square" onClick={onSquareClick} style={{'backgroundColor': gridBackColor }}>
      {value}
    </button>
    );
  }

  return (
    <section className='TicTacToe_global_section'>
    <div className='TicTacToe_main_section'>
        <h1 className='TicTacToe_game_title'>Morpion</h1>
      <p className='TicTacToe_game_rule '>Pour gagner la partie, aligne trois symboles identiques.</p>
      <div className='game'>
      <div className="status">{status}</div> 
        <div className='board'>
          <div className="grid_row">
            <Grid value={gridMemory[0]} onSquareClick={() => {handleClick(0)}} gridBackColor={backColor[0]} />
            <Grid value={gridMemory[1]} onSquareClick={() => {handleClick(1)}} gridBackColor={backColor[1]}/>
            <Grid value={gridMemory[2]} onSquareClick={() => {handleClick(2)}} gridBackColor={backColor[2]}/>
          </div>
          <div className="grid_row">
            <Grid value={gridMemory[3]} onSquareClick={() => handleClick(3)} gridBackColor={backColor[3]}/>
            <Grid value={gridMemory[4]} onSquareClick={() => handleClick(4)} gridBackColor={backColor[4]}/>
            <Grid value={gridMemory[5]} onSquareClick={() => handleClick(5)} gridBackColor={backColor[5]}/>
          </div>
          <div className="grid_row">
            <Grid value={gridMemory[6]} onSquareClick={() => handleClick(6)} gridBackColor={backColor[6]}/>
            <Grid value={gridMemory[7]} onSquareClick={() => handleClick(7)} gridBackColor={backColor[7]}/>
            <Grid value={gridMemory[8]} onSquareClick={() => handleClick(8)} gridBackColor={backColor[8]}/>
          </div>
          <div className='morpion_two_buttons'>
            <button className='reset' onClick ={() => Reset()}>Recommencer</button>
            <a href='/morpion-contre-adversaire'><button className='two_players'>Deux joueurs</button></a> 
          </div>
        </div>
      </div>
    </div>
    <div>
        <Sidebar/>
    </div>
      </section>
  );
}


